import styled from '@emotion/styled';
import { rem } from '@utils';

const Block = styled.div<{ layout: 'horizontal' | 'vertical' }>`
  display: flex;
  flex-direction: ${({ layout }) =>
    layout === 'horizontal' ? 'row' : 'column'};
  flex-wrap: wrap;
  gap: ${rem(12)};
  margin: ${rem(16)} 0 ${rem(8)};
  width: 100%;
`;

const chartCardSizing = ({
  layout,
  minWidth,
  widthPercent
}: {
  layout: 'horizontal' | 'vertical';
  minWidth: number;
  widthPercent: number;
}) => {
  if (widthPercent !== undefined) {
    if (layout === 'horizontal') {
      return `
        flex: 1 1 calc(${widthPercent}% - ${rem(12)});
        max-width: 100%;
        min-width: ${rem(minWidth)};
      `;
    }

    return `
      align-self: flex-start;
      max-width: 100%;
      min-width: min(100%, ${minWidth});
      width: ${widthPercent}%;
    `;
  }

  if (layout === 'horizontal') {
    return `
      flex: 1 1 0;
      max-width: 100%;
      min-width: ${rem(minWidth)};
    `;
  }

  return `
    min-width: min(100%, ${minWidth});
    width: 100%;
  `;
};

const ChartCard = styled.div<{
  layout: 'horizontal' | 'vertical';
  minWidth: number;
  widthPercent: number;
}>`
  border: 1px solid ${({ theme }) => theme.palette.grey['200']};
  border-radius: ${rem(8)};
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
  overflow: hidden;
  padding: ${rem(16)};
  ${chartCardSizing}
`;

const ErrorText = styled.div`
  color: ${({ theme }) => theme.palette.grey['600']};
  font-size: ${rem(13)};
  margin: 0;
  text-align: center;
`;

const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: ${rem(80)};
`;

export default {
  Block,
  ChartCard,
  ErrorText,
  LoadingContainer
};
